import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useDemo } from "@/context/DemoContext";

export function Footer() {
  const { openDemo } = useDemo();
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/10 bg-background">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              The complete operating platform for field service businesses — built by engineers, for engineers.
            </p>
            <button
              onClick={() => openDemo("demo")}
              className="mt-5 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.03]"
              data-testid="footer-book-demo"
            >
              Book a Demo
            </button>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Platform</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link className="transition-colors hover:text-primary" to="/">Home</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/features">Features</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/lean-operations">Lean Operations</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/pricing">Pricing</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/about">About</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Legal</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link className="transition-colors hover:text-primary" to="/contact">Privacy Policy</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/contact">Cookie Policy</Link></li>
              <li><Link className="transition-colors hover:text-primary" to="/contact">Terms &amp; Conditions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Get in touch</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li>support@flowcoreplus.co.uk</li>
              <li>Mon–Fri, 9am–5pm</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-muted-foreground sm:flex-row">
          <p>© {year} FlowCore. All rights reserved.</p>
          <p>flowcoreplus.co.uk</p>
        </div>
      </div>
    </footer>
  );
}
